<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="pageTitle"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />

    @if (windowService.isDesktopRes) {
      <tidy-desktop-header>
        <div class="wrappable-container">
          <tidy-image
            [src]="'assets/svg/arrow-back-black.svg'"
            (action)="goBack()"
            class="desktop-back-icon" />
          <tidy-text [title]="pageTitle" />
        </div>
      </tidy-desktop-header>
    }

    <tidy-card>
      <tidy-row [align]="'center'" style="justify-content: center; margin-bottom: 12px;">
        <tidy-image
          [src]="'assets/img/tidy-wifi-noise-sensor.png'"
          style="width: 100px; height: 100px; border-radius: 8px; object-fit: contain;" />
      </tidy-row>
      <tidy-row>
        <tidy-text [header]="'TIDY Wi-Fi Router & Noise Sensor'" />
      </tidy-row>
      <tidy-row>
        <tidy-text [body]="description" />
      </tidy-row>
    </tidy-card>

    <tidy-card>
      <tidy-row>
        <tidy-text [header]="'What\'s Included'" />
      </tidy-row>
      @for (feature of features; track feature) {
        <tidy-row>
          <tidy-text [body]="feature" />
        </tidy-row>
      }
    </tidy-card>

    <tidy-card>
      <tidy-row>
        <tidy-text [header]="'Technical Specs'" />
      </tidy-row>
      @for (spec of specs; track spec.label) {
        <tidy-row [alignLastItemRight]="true">
          <tidy-text [body]="spec.label" />
          <tidy-text [body]="spec.value" />
        </tidy-row>
      }
    </tidy-card>

    <tidy-card>
      <tidy-row>
        <tidy-text [header]="'FAQ'" />
      </tidy-row>
      @for (faq of faqs; track faq.question) {
        <tidy-row>
          <tidy-text [title]="faq.question" />
        </tidy-row>
        <tidy-row>
          <tidy-text [body]="faq.answer" />
        </tidy-row>
      }
    </tidy-card>

    <tidy-button
      [text]="'Order Sensor'"
      [action]="boundOrderSensor"
      class="primary" />
  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper
  [isfullWidthContent]="windowService.isDesktopRes"
  [templateContent]="content" />
